import {IconButton, Stack, Tooltip} from "@mui/material";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import {Highlighter} from "../../common/Highlighter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import React from "react";
import {Proposal} from "../../../types/Proposal";
import {useAuthStore} from "../../../store/auth.store";
import {ProposalFilter} from "../../../service/proposal.service";
import {PremiumMessageElementProperties} from "../PremiumMessageElement";

interface Props {
    row: Proposal,
    filter: ProposalFilter
    setShowPremiumMessageEl: (el:PremiumMessageElementProperties) => void
}

export function ProposalPhoneCell({row, filter, setShowPremiumMessageEl}:Props) {
    const {can, jwt} = useAuthStore();
    const canManage = can('manage_proposals');

    return <Stack flexDirection={"row"} alignItems={"center"}>
        <Stack>
            {!jwt &&
                <IconButton onClick={(e) => setShowPremiumMessageEl({
                    element: (e.target as Element),
                    isOpen: true,
                    isFavorite: false,
                    isFavoriteInTable: false,
                    isPhone: true,
                    isPdf: false,
                    isMy: false,
                    isSupport: false,
                })}>
                    <PermPhoneMsgIcon color={"info"}/>
                </IconButton>}
            {(jwt || canManage) && !!row.phone && row.phone.split(",").map((phone, index) => {
                const content = <Highlighter text={phone} search={filter.phone}/>;
                if (canManage && row.samePhones > 1) {
                    return <Tooltip key={phone + "_" + index}
                                    title={"Total amount of same phones " + row.samePhones}>
                                    <span className={"bold"}>
                                        {content}
                                    </span>
                    </Tooltip>
                } else {
                    return <div key={phone + "_" + index}>
                        {content}
                    </div>
                }
            })}
        </Stack>

        {row.whatsapp &&
            <IconButton href={`https://wa.me/${row.whatsapp}`} target="_blank" rel="noopener noreferrer">
                <WhatsAppIcon color={"success"}/>
            </IconButton>}
    </Stack>
}